import { z } from 'zod';

export const BusinessBranchOptionDTO = z.object({
  id: z.number().optional(),
  branch_id: z.number(),
  business_id: z.number().optional(),
  branch_options_id: z.number(),
  field_value: z.string(),
});

export type BusinessBranchOption = z.TypeOf<typeof BusinessBranchOptionDTO>;

export const exampleBusinessBranchOption: BusinessBranchOption = {
  branch_id: 1,
  business_id: 1,
  branch_options_id: 1,
  field_value: '200',
};
